import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class BloqueFijasService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getBloques(): Observable<any> {
    const url =
      Constants.BASE_URL_DOS + Constants.URL_BLOQUE_FIJAS + "/vEPa001/";
    return this.http.get<any>(url).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Bloque",
            text: "Error cargando registros.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getBloquesCombox(): Observable<any> {
    const url =
      Constants.BASE_URL_DOS + Constants.URL_BLOQUE_FIJAS + "/vEPa003/";
    return this.http.get<any>(url).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Bloque",
            text: "Error cargando registros.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getBloquesId(idBloque): Observable<any> {
    const url =
      Constants.BASE_URL_DOS +
      Constants.URL_BLOQUE_FIJAS +
      "/vEPa002/" +
      idBloque;
    return this.http.get<any>(url).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Bloque",
            text: "Error cargando registros.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public postBloquesCrear(parmametrosJson): Observable<any> {
    const url =
      Constants.BASE_URL_DOS + Constants.URL_BLOQUE_FIJAS + "/vEPa003/";
    return this.http.post<any>(url, parmametrosJson).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else if (err.status === 409) {
          Swal.fire({
            title: "Error Bloque",
            text: "Este codigo ya existe, veirifique la información.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        } else {
          Swal.fire({
            title: "Error Bloque",
            text: "Verifique la informacion ingresada.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        }

        return throwError(err);
      })
    );
  }

  public putBloques(parmametrosJson): Observable<any> {
    const url =
      Constants.BASE_URL_DOS + Constants.URL_BLOQUE_FIJAS + "/vEPa004/";
    return this.http.put<any>(url, parmametrosJson).pipe(
      catchError((err) => {
        Swal.fire({
          title: "Error Bloque",
          text: "Error actualizando registro.",
          icon: "error",
        });
        return throwError(err);
      })
    );
  }

  public deleteBloques(parmametrosJson): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      body: parmametrosJson,
    };
    const url =
      Constants.BASE_URL_DOS + Constants.URL_BLOQUE_FIJAS + "/vEPa005/";
    return this.http.delete<any>(url, options).pipe(
      catchError((err) => {
        Swal.fire({
          title: "Error Bloque",
          text: "Error eliminando registro.",
          icon: "error",
        });
        return throwError(err);
      })
    );
  }
}
